const PRODUCT_EXPANDS = 'expand[]=options&expand[]=variants';

export default {
    data() {
        return {
            productsPerPage: 25,
            productsPage: 1,
            isLoadingProducts: false,
            isLoadingProduct: false,
            isLoadingCheckoutUrl: false,
            checkOutUrlErrorMessage: null
        };
    },
    computed: {
        preselectedProductsUrl() {
            return `/api/v1/campaigns/${this.campaignParamId}/preselected-products?expand[]=variants`;
        },
        checkoutProductsUrl() {
            return `/api/v1/campaigns/${this.campaignParamId}/checkout-products`;
        },
        shopifyProductUrl() {
            return `/api/v1/campaigns/${this.campaignParamId}/product-handle`;
        },
        preselectedProducts() {
            return this.$root.v2.preselectedProducts;
        },
        loadedProducts() {
            return this.$root.v2.loadedProducts;
        },
        productRestriction() {
            if (this.$route.query.restriction) {
                return JSON.parse(decodeURIComponent(this.$route.query.restriction));
            }

            return null;
        },
        collectionId() {
            return this.$route.query.collection_id;
        },
        wizardProducts() {
            return this.$root.v2.wizardProducts;
        },
        wizardProduct() {
            return this.$root.v2.wizardProduct;
        },
        productId() {
            return this.$route.params.product_id;
        },
        wizardUrl() {
            return `/api/v1/campaigns/${this.campaignParamId}/wizard-products`;
        },
        productUrl() {
            return `/api/v1/products/${this.productId}?expand[]=variants`;
        }
    },
    methods: {
        getVariant(product) {
            return product.variants.find((variant) => variant.id === product.variant_id);
        },
        loadPreselectedProducts() {
            if (!this.isCampaignDirty && this.$root.v2.preselectedProducts.length > 0) {
                return Promise.resolve();
            }

            return this.$http.get(this.preselectedProductsUrl).then((res) => {
                // Map selected products into data format needed
                const mapped = res.data.map((product) => {
                    product.variant = this.getVariant(product);
                    return product;
                });

                this.$root.v2.preselectedProducts = mapped;

                if (this.$root.v2.loadedProducts.length < 1) {
                    this.$root.v2.loadedProducts = mapped;
                }
            });
        },
        loadCheckoutUrlProducts(data) {
            this.checkOutUrlErrorMessage = null;

            if (data.payload.url.length === 0) {
                this.checkOutUrlErrorMessage = "Oops, empty URL. Let's try this again.";
                return;
            }

            this.isLoadingCheckoutUrl = true;

            this.$http
                .get(`${this.checkoutProductsUrl}?url=${data.payload.url}`)
                .then((res) => {
                    this.$root.v2.loadedProducts = res.data.map((product) => {
                        product.variant = this.getVariant(product);
                        return product;
                    });
                })
                .catch(() => {
                    this.checkOutUrlErrorMessage = "Oops, wrong URL. Let's try this again.";
                })
                .then(() => {
                    this.isLoadingCheckoutUrl = false;
                });
        },
        loadProductUrl(url) {
            this.checkOutUrlErrorMessage = null;

            if (url && url.length === 0) {
                this.checkOutUrlErrorMessage = "Oops, empty URL. Let's try this again.";
                return;
            }

            this.isLoadingCheckoutUrl = true;

            this.$http
                .get(`${this.shopifyProductUrl}?${PRODUCT_EXPANDS}&url=${url}`)
                .then((res) => {
                    const product = res.data;

                    if (product.has_options) {
                        this.$router.push({
                            name: 'v2.productSelection.product',
                            params: { product_id: product.id },
                            query: {
                                productIndex: this.$root.v2.loadedProducts.length,
                                variantId: null
                            }
                        });
                    } else {
                        product.variant = this.getVariant(product);
                        this.$root.v2.loadedProducts.push(product);
                    }
                })
                .catch(() => {
                    this.checkOutUrlErrorMessage = "Oops, wrong URL. Let's try this again.";
                })
                .then(() => {
                    this.isLoadingCheckoutUrl = false;
                });
        },
        loadProduct() {
            this.isLoadingProduct = true;

            return this.$http.get(this.productUrl).then((res) => {
                this.$root.v2.wizardProduct = res.data;
            });
        },
        loadProducts() {
            this.isLoadingProducts = true;

            return this.$http
                .get(this.wizardUrl, {
                    params: {
                        restriction: this.productRestriction,
                        category_id: this.collectionId,
                        per_page: this.productsPerPage,
                        page: this.productsPage
                    }
                })
                .then((res) => {
                    this.$root.v2.wizardProducts = res.data;
                })
                .catch((error) => this.handleHttpError(error))
                .then(() => {
                    this.isLoadingProducts = false;
                });
        },
        getNextProductsPage() {
            this.productsPage = this.productsPage + 1;
            return this.loadProducts();
        },
        getPreviousProductsPage() {
            if (this.productsPage === 1) {
                return;
            }
            this.productsPage = this.productsPage - 1;
            return this.loadProducts();
        }
    }
};
